import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signal"]
  static values = { url: String, interval: { type: Number, default: 5 * 60 * 1000 } }

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  // A broadcast from the scan job replaces the signal element, which re-connects
  // this target and fetches the card straight away in the viewer's own session.
  signalTargetConnected() {
    if (this.initialSignalSeen) this.poll()
    this.initialSignalSeen = true
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "text/html" } })
      if (response.status === 204) return // still scanning — keep polling
      if (!response.ok) return

      const html = await response.text()
      this.disconnect()
      this.element.outerHTML = html // swap whole card; Stimulus re-binds children
    } catch (error) {
      console.error("Antivirus poll failed:", error)
    }
  }
}
